/* eslint-disable camelcase */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'lodash';
import ReactGA from 'react-ga';
import get from 'lodash/get';
import has from 'lodash/has';
import flow from 'lodash/fp/flow';
import _map from 'lodash/fp/map';
import _some from 'lodash/fp/some';
import some from 'lodash/some';
import isEmpty from 'lodash/isEmpty';
import includes from 'lodash/includes';
import { OnboardingStep, ContactInformationPopup } from '../../components/';
import {
  goToStep,
  selectStepValue,
  selectStepInputValue,
  setPrevStep,
  setCurrentOnboardingStep,
  setCurrentSection,
  updateProjectBrief,
  uploadFile,
  uploadingAttachmentRequest,
  uploadingProjectPictureRequest,
  removeUpload,
  addReference,
  deleteReferenceVideo,
  updateReference,
  updateFreeComment,
  addDropboxFolder,
  removeDropboxFolder,
  setBudget,
  getBudget,
  fetchFreelancers,
  changeManagementDescription,
  updateFreelancerPreFilter,
  requestBid,
  deleteBid,
  bookNow,
} from '../../store/actions/Onboarding';
import { saveProgress } from '../../store/actions/Dashboard';
import {
  getNextOnboardingStep,
  getPrevOverviewSteps,
  getFreelancerPreFilter,
  routesAction,
  scrollUp,
} from '../../shared/helpers';
import { openDialog, closeDialog } from '../../store/actions/Dialog';
import {
  BottomBarDetail,
  BottomBarHeader,
} from '../../components/BottomBar/ManagedBottomBar';
import {
  hideBottomBar,
  openBottomBar,
  toggleBottomBarDetail,
} from '../../store/actions/BottomBar';
import { BottomBar } from '../../components/BottomBar';
import { addFlashMessage } from '../../store/actions/Flash';
import { FreelancerChooserPopup } from '../../components/Popup/FreelancerChooserPopup';
import { FreelancerProfilePopup } from '../../components/Popup/FreelancerProfilePopup';
import { FreelancerTooManyCreatorsPopup } from '../../components/Popup/FreelancerTooManyCreatorsPopup';
import { EndingEarlyPopup } from '../../components/Popup/EndingEarlyPopup';
import { FreelancerSelectedOnePopup } from '../../components/Popup/FreelancerSelectedOnePopup';
import { WelcomePopup } from '../../components/Popup/WelcomePopup';
import { getProject } from '../../store/actions/ProjectView';

const filters = {
  touchedStep: step => step.status !== 'empty',
};

class Onboarding extends Component {
  constructor(props) {
    super(props);
    this.handleNextStep = this.handleNextStep.bind(this);
    this.handlePrevStep = this.handlePrevStep.bind(this);
    this.handleCardSelected = this.handleCardSelected.bind(this);
    this.handleSaveProgress = this.handleSaveProgress.bind(this);
    this.handleGoToAnswer = this.handleGoToAnswer.bind(this);
    this.handleCardInputChange = this.handleCardInputChange.bind(this);
    this.handleGoToSection = this.handleGoToSection.bind(this);
    this.handleAddReference = this.handleAddReference.bind(this);
    this.handleDeleteReference = this.handleDeleteReference.bind(this);
    this.handleProjectBriefInput = this.handleProjectBriefInput.bind(this);
    this.handleReferenceInputChange = this.handleReferenceInputChange.bind(
      this,
    );
    this.handleFreeCommentInputChange = this.handleFreeCommentInputChange.bind(
      this,
    );
    this.handleProjectUpload = this.handleProjectUpload.bind(this);
    this.handleRemoveUpload = this.handleRemoveUpload.bind(this);
    this.handleContact = this.handleContact.bind(this);
    this.handleAddDeadline = this.handleAddDeadline.bind(this);
    this.handleAddContactInfo = this.handleAddContactInfo.bind(this);
    this.handleSaveManagementWay = this.handleSaveManagementWay.bind(this);
    this.handleGoToDashboard = this.handleGoToDashboard.bind(this);
    this.handleBudgetChange = this.handleBudgetChange.bind(this);
    this.handleSaveContactInfo = this.handleSaveContactInfo.bind(this);
    this.openContactInformationPopup = this.openContactInformationPopup.bind(
      this,
    );
  }

  componentDidMount() {
    this.openWelcomePopup();
  }

  openWelcomePopup() {
    const { dispatchOpenDialog, dispatchCloseDialog, user } = this.props;

    const welcomePopupKey = `welcome_popup_${user.id}`;

    const welcomePopupDidOpen = localStorage.getItem(welcomePopupKey);

    if (welcomePopupDidOpen) return;

    const welcomePopup = {
      id: 'welcome-popup',
      body: (
        <WelcomePopup
          handleNext={dispatchCloseDialog}
          userName={this.getUserName()}
        />
      ),
    };

    dispatchOpenDialog(welcomePopup, { className: 'modal-sm' });
    localStorage.setItem(welcomePopupKey, true);
  }

  getUserName() {
    const { user } = this.props;
    const [userName] = user.name ? user.name.split(' ') : '';
    return userName;
  }

  handleBudgetChange(budget) {
    const { dispatchSetBudget } = this.props;
    dispatchSetBudget(budget);
  }

  hideBottomBar = () => {
    const { bottomBarOpened, dispatchHideBottomBar } = this.props;
    if (bottomBarOpened) {
      dispatchHideBottomBar();
    }
  };

  saveSteps() {
    const {
      currentOnboardingSteps,
      dispatchSaveProgress,
      currentOnboardingStep,
      currentOverviewStep,
      isFetchingProjects,
      match: {
        params: { project_id: projectId },
      },
      budget,
      history: { push },
      dispatchGetProject,
    } = this.props;

    const step = this.getCurrentStep();

    const steps = {
      deadline: () => {
        if (!step.selectedValue && !step.project_name) return;

        const [deadline] = step.selectedValue;
        const { project_name, project_picture } = step;

        dispatchSaveProgress(
          {
            deadline,
            project_name,
            project_picture,
            current_onboarding_step: getNextOnboardingStep(
              currentOnboardingStep,
            ),
            current_overview_step: currentOverviewStep,
            answered_questions: [
              { key: 'deadline', question_response: [deadline] },
            ],
          },
          projectId,
          isFetchingProjects,
        );
      },
      managed_marketplace: () => {
        if (_.isEmpty(step.selectedValue)) return;
        this.saveManagementWay(step, projectId);
      },
      budget: () => {
        dispatchSaveProgress(
          {
            price_selected: budget,
            current_onboarding_step: getNextOnboardingStep(
              currentOnboardingStep,
            ),
          },
          projectId,
        );
      },
      free_comment: () => {
        if (!step.selectedValue && !step.comment) return;

        const [comment] = step.selectedValue;

        dispatchSaveProgress(
          {
            comment,
            answered_questions: [
              { key: 'free_comment', question_response: [comment] },
            ],
          },
          projectId,
          isFetchingProjects,
        );

        if (currentOnboardingSteps.status === 'unsubmitted') {
          this.openContactInformationPopup(this.showEndingPopup());
        } else {
          dispatchGetProject(projectId).then(() => {
            push(routesAction.project(projectId));
          });
        }
      },
      url_link: () => {
        const { references } = step;

        const [reference] = references;

        dispatchSaveProgress(
          {
            references,
            current_onboarding_step: getNextOnboardingStep(
              currentOnboardingStep,
            ),
            answered_questions: [
              { key: 'url_link', question_response: [reference.link] },
            ],
          },
          projectId,
        );
      },
    };

    if (_.has(steps, currentOnboardingStep)) {
      steps[currentOnboardingStep]();
    }
  }

  saveManagementWay(step, projectId) {
    const {
      dispatchSaveProgress,
      currentOnboardingStep,
      currentOverviewStep,
      isFetchingProjects,
      history,
    } = this.props;

    const [first, second, third] = step.selectedValue;

    const { endEarly } = step;

    dispatchSaveProgress(
      {
        ...first,
        ...second,
        ...third,
        current_onboarding_step: getNextOnboardingStep(currentOnboardingStep),
        current_overview_step: currentOverviewStep,
        status: endEarly ? 'pending' : 'unsubmitted',
      },
      projectId,
      isFetchingProjects,
    ).then(() => {
      if (endEarly) {
        this.showEndingPopup();
        history.push(routesAction.default());
      }
    });
  }

  showEndingPopup() {
    const { dispatchOpenDialog, dispatchCloseDialog, history } = this.props;
    dispatchOpenDialog(
      {
        id: 'summary-popup',
        body: (
          <EndingEarlyPopup
            handleCloseDialog={() => {
              dispatchCloseDialog();
              history.push(routesAction.default());
            }}
          />
        ),
      },
      {
        closeOnEscape: false,
        closeOnDimmerClick: false,
        closable: 'true',
      },
    );
  }

  getCurrentStep() {
    const {
      currentOnboardingSteps,
      currentOnboardingStep,
      currentOverviewStep,
    } = this.props;

    return currentOnboardingSteps[currentOverviewStep].onboardingSteps.find(
      onboardingStep => onboardingStep.key === currentOnboardingStep,
    );
  }

  sendStepAnalyticsEvent() {
    const step = this.getCurrentStep();
    const stepValuesMapper = {
      deadline: st => ({
        action: st.name,
        label: `Project Name: ${st.project_name} Deadline: ${st.selectedValue}`,
      }),
      type: st => ({
        action: st.name,
        label: st.selectedValue.join(', '),
      }),
    };

    const event = has(stepValuesMapper, step.key)
      ? stepValuesMapper[step.key](step)
      : { action: step.name };

    ReactGA.event({
      category: 'Onboarding',
      ...event,
    });
  }

  handleNextStep(event) {
    event.preventDefault();
    this.hideBottomBar();
    this.saveSteps();
    const finalSteps = ['free_comment', 'soundtrack', 'voiceover'];
    const overviewStep = this.props.currentOverviewStep;

    this.sendStepAnalyticsEvent();
    if (finalSteps.includes(this.props.currentOnboardingStep)) {
      return;
    }

    this.props.dispatchSetNextStep(overviewStep);

    scrollUp();
  }

  handlePrevStep(event) {
    event.preventDefault();
    const {
      dispatchSetPrevStep,
      currentOnboardingStep,
      currentOverviewStep,
      currentProject,
      project,
      history: { push },
    } = this.props;
    this.hideBottomBar();
    const initialSteps = this.getInitialEnabledSteps();
    if (initialSteps.includes(currentOnboardingStep)) {
      if (currentProject === project.id) {
        push(routesAction.project(project.id));
      } else {
        push(routesAction.default());
      }
    } else {
      dispatchSetPrevStep(currentOverviewStep);
    }
    scrollUp();
  }

  handleGoToAnswer(onboardingStep) {
    this.props.dispatchGoToQuestionStep(onboardingStep);
    this.props.history.push(
      routesAction.onboarding(this.props.match.params.project_id),
    );
    scrollUp();
  }

  handleGoToDashboard(event) {
    event.preventDefault();

    const {
      dispatchSaveProgress,
      currentOnboardingStep,
      history,
      match: {
        params: { project_id: projectId },
      },
    } = this.props;

    dispatchSaveProgress(
      { status: 'pending', current_onboarding_step: currentOnboardingStep },
      projectId,
      false,
    ).then(() => {
      history.push(routesAction.default());
    });
  }

  handleSaveProgress(event) {
    event.preventDefault();
    const {
      currentOnboardingStep: onboardingStep,
      currentOverviewStep: overviewStep,
      currentOnboardingSteps,
      match,
      isFetchingProjects,
    } = this.props;

    const answeredQuestions = [];
    const projectId = match.params.project_id;
    const stepsToSave = getPrevOverviewSteps(overviewStep).concat(overviewStep);
    let projectName = '';
    let projectBrief = '';
    let projectPicture = '';
    let attachments = [];
    let refs = [];

    _.forEach(stepsToSave, stepToSave => {
      const onboardingStepsInfo =
        currentOnboardingSteps[stepToSave].onboardingSteps;

      _.forEach(onboardingStepsInfo, onboardingStepInfo => {
        if (onboardingStepInfo.attachments) {
          attachments = [
            ...attachments,
            ...onboardingStepInfo.attachments.map(attach => {
              const { name, url, _destroy, id } = attach;

              return { name, url, _destroy, id };
            }),
          ];
        }

        if (onboardingStepInfo.project_picture) {
          projectPicture = onboardingStepInfo.project_picture;
        }

        if (onboardingStepInfo.project_name) {
          projectName = onboardingStepInfo.project_name;
        }

        if (onboardingStepInfo.project_brief) {
          projectBrief = onboardingStepInfo.project_brief;
        }

        if (onboardingStepInfo.references) {
          refs = onboardingStepInfo.references;
        }
        answeredQuestions.push({
          key: onboardingStepInfo.key,
          question_response: onboardingStepInfo.selectedValue,
          input_value:
            onboardingStepInfo.selectedValue.includes('other') &&
            onboardingStepInfo.cards.find(elem => elem.value === 'other')
              .inputValue,
        });
      });
    });

    const saveInfo = {
      attachments_attributes: attachments,
      project_picture: projectPicture,
      project_name: projectName,
      project_brief: projectBrief,
      references: refs,
      current_overview_step: overviewStep,
      current_onboarding_step: getNextOnboardingStep(onboardingStep),
      answered_questions: answeredQuestions,
    };

    this.props.dispatchSaveProgress(saveInfo, projectId, isFetchingProjects);
  }

  isAlreadySelectedSingleChoiceCard(value, { selectedValue, type }) {
    return includes(selectedValue, value) && type === 'single';
  }

  handleCardSelected(
    event,
    { value, is_hand: isHandCard },
    resourceFolders = null,
  ) {
    event.preventDefault();

    const {
      dispatchSaveProgress,
      dispatchErrorMessage,
      currentOnboardingStep: step,
      currentOverviewStep: overviewStep,
      currentOverviewStep,
      currentOnboardingSteps,
      isFetchingProjects,
      dispatchAddDropboxFolder,
      dispatchRemoveDropboxFolder,
    } = this.props;

    const onboardingStep = currentOnboardingSteps[
      overviewStep
    ].onboardingSteps.find(elem => elem.key === step);

    let currentValues = onboardingStep.selectedValue;

    if (
      this.isAlreadySelectedSingleChoiceCard(value, onboardingStep) &&
      event.type !== 'change'
    ) {
      return;
    }

    if (!_.isNil(resourceFolders)) {
      dispatchAddDropboxFolder(overviewStep, step, resourceFolders);
    } else if (step === 'files') {
      dispatchRemoveDropboxFolder(overviewStep, step);
    }

    this.checkShowBottomBarState(
      isHandCard,
      currentOverviewStep,
      onboardingStep,
      value,
    );

    const dontKnowAnswer = 'dont_know';

    if (onboardingStep.type === 'multi') {
      const getInnerCard = inner => inner.value === value;
      const getCard = onboardinCard =>
        onboardinCard.inner_cards.find(getInnerCard);
      const card = onboardingStep.cards.find(getCard);

      const cardValues = card.inner_cards.map(inner => inner.value);
      const selectedCardResponses = currentValues.filter(currentValue =>
        cardValues.includes(currentValue),
      );

      if (card.type === 'single') {
        const innerValues = card.inner_cards.map(inner => inner.value);
        currentValues = currentValues.filter(cv => !innerValues.includes(cv));
        currentValues = [...currentValues, value];
      } else if (currentValues.includes(value)) {
        currentValues.splice(currentValues.indexOf(value), 1);
      } else if (card.max_responses !== selectedCardResponses.length) {
        currentValues.push(value);
      } else {
        dispatchErrorMessage(
          `Maximum ${card.max_responses} responses for this question.`,
        );
      }
    } else if (
      onboardingStep.type === 'multiple_choice' &&
      value !== dontKnowAnswer
    ) {
      if (currentValues.includes(dontKnowAnswer)) {
        currentValues.splice(currentValues.indexOf(dontKnowAnswer), 1);
      }

      if (currentValues.includes(value)) {
        currentValues.splice(currentValues.indexOf(value), 1);
      } else {
        currentValues.push(value);
      }
    } else {
      currentValues = [value];
    }

    if (onboardingStep.type === 'multi') {
      const currentSection = onboardingStep.current_section;

      const sectionsResponses = ['help_choosing'];

      if (
        currentSection < onboardingStep.number_of_sections - 1 &&
        currentValues.includes(value) &&
        (onboardingStep.key === 'soundtrack' &&
          sectionsResponses.includes(value))
      ) {
        this.props.dispatchGoToSection(overviewStep, step, currentSection + 1);
      }
    }

    this.props.dispatchSelectStepValue(step, overviewStep, currentValues);

    const answeredQuestions = [];
    const projectId = this.props.match.params.project_id;
    const stepsToSave = getPrevOverviewSteps(currentOverviewStep).concat(
      currentOverviewStep,
    );

    let projectName = '';
    let projectBrief = '';
    let projectPicture = '';
    let attachments = [];
    let refs = [];

    const filesStep = _(stepsToSave)
      .map(stp => currentOnboardingSteps[stp].onboardingSteps)
      .flatMap()
      .find(onbStep => onbStep.key === 'files');

    const dropboxUrls = this.getDropboxUrl(step, resourceFolders, filesStep);

    _.forEach(stepsToSave, stepToSave => {
      const onboardingStepsInfo =
        currentOnboardingSteps[stepToSave].onboardingSteps;

      _.forEach(onboardingStepsInfo, onboardingStepInfo => {
        if (onboardingStepInfo.attachments) {
          attachments = [
            ...attachments,
            ...onboardingStepInfo.attachments.map(attach => {
              const { name, url, _destroy, id } = attach;

              return { name, url, _destroy, id };
            }),
          ];
        }

        if (onboardingStepInfo.project_picture) {
          projectPicture = onboardingStepInfo.project_picture;
        }

        if (onboardingStepInfo.project_name) {
          projectName = onboardingStepInfo.project_name;
        }

        if (onboardingStepInfo.project_brief) {
          projectBrief = onboardingStepInfo.project_brief;
        }

        if (onboardingStepInfo.references) {
          refs = onboardingStepInfo.references;
        }

        answeredQuestions.push({
          key: onboardingStepInfo.key,
          question_response: onboardingStepInfo.selectedValue,
          input_value: onboardingStepInfo.selectedValue.includes('other')
            ? this.getOnboardingStepCardInputValue(onboardingStepInfo, 'other')
            : '',
        });
      });
    });

    const answered_questions = answeredQuestions.map(
      question =>
        question.key === step
          ? { ...question, question_response: currentValues }
          : question,
    );

    const saveInfo = {
      attachments_attributes: attachments,
      project_picture: projectPicture,
      dropbox_urls: dropboxUrls,
      project_name: projectName,
      project_brief: projectBrief,
      references: refs,
      current_overview_step: overviewStep,
      current_onboarding_step: onboardingStep.key,
      answered_questions,
    };

    dispatchSaveProgress(saveInfo, projectId, isFetchingProjects);

    this.cleanUpSubmitOnThrowBack();
  }

  getOnboardingStepCardInputValue = ({ type, cards }, key) => {
    if (type !== 'multi') {
      return cards.find(elem => elem.value === key).inputValue;
    }

    const item = _(cards)
      .flatMap(crd => crd.inner_cards)
      .find(elem => elem.value === key);
    return get(item, 'inputValue', null);
  };

  cleanUpSubmitOnThrowBack() {
    const {
      currentOnboardingSteps: {
        submit: { onboardingSteps },
      },
      match: {
        params: { project_id: projectId },
      },
      dispatchSaveProgress,
      isFetchingProjects,
    } = this.props;

    const isSubmitTouched = !_(onboardingSteps)
      .filter(filters.touchedStep)
      .isEmpty();

    if (isSubmitTouched) {
      dispatchSaveProgress(
        {
          means_of_contact: null,
          phone_number: null,
          email: null,
          price_selected: null,
        },
        projectId,
        isFetchingProjects,
      );
    }
  }

  handleShowFreelancerChooserPopup = () => {
    const {
      dispatchOpenDialog,
      dispatchCloseDialog,
      dispatchFetchFreelancers,
      currentOnboardingSteps,
      dispatchUpdateFreelancerPreFilter,
      currentProject,
    } = this.props;

    const freelancerPreFilter = getFreelancerPreFilter(currentOnboardingSteps);

    dispatchUpdateFreelancerPreFilter(freelancerPreFilter);

    dispatchFetchFreelancers().then(action => {
      if (action.type === 'FETCHING_FREELANCERS_SUCCESS') {
        const hasBidedFreelancer = flow(
          _map(freelancer => {
            const bidRequested = some(freelancer.bids, {
              project_id: parseInt(currentProject, 10),
            });
            return { ...freelancer, bidRequested };
          }),
          _some({ bidRequested: true }),
        )(this.props.freelancers);

        if (!hasBidedFreelancer) {
          const freelancerChooserPopup = {
            id: 'freelancer-chooser-popup',
            body: (
              <FreelancerChooserPopup
                handleSelectYourExpert={dispatchCloseDialog}
              />
            ),
          };

          dispatchOpenDialog(freelancerChooserPopup);
        }
      }
    });
  };

  handleShowTooManyCreatorsPopup = () => {
    const { dispatchOpenDialog, dispatchCloseDialog } = this.props;

    const freelancerChooserPopup = {
      id: 'freelancer-too-many=creators-popup',
      body: (
        <FreelancerTooManyCreatorsPopup
          handleEditSelections={dispatchCloseDialog}
          handleFinish={() => {
            dispatchCloseDialog();
            this.handleNextStep({ preventDefault: () => {} });
          }}
        />
      ),
    };

    dispatchOpenDialog(freelancerChooserPopup);
  };

  getDropboxUrl(step, resourceFolders, filesStep) {
    if (step === 'files') {
      if (!_.isNil(resourceFolders)) {
        return resourceFolders.map(resource => resource.link);
      }
    } else if (filesStep && filesStep.dropboxPaths) {
      return filesStep.dropboxPaths;
    }
    return null;
  }

  checkShowBottomBarState(
    isHandCard,
    currentOverviewStep,
    { selectedValue: selectedValues, cards: stepCards, type: stepType },
    selectedValue,
  ) {
    const isBasicInformation = currentOverviewStep === 'basic_information';
    const isMultipleChoice = stepType === 'multiple_choice';
    const isNewSelectedValue = this.isNewSelectedValue(
      selectedValues,
      selectedValue,
    );
    const hasHandCards = this.hasHandCards(
      stepCards,
      selectedValues,
      selectedValue,
    );

    // Single choice
    if (isHandCard && isBasicInformation && !isMultipleChoice) {
      this.props.dispatchOpenBottomBar();
    } else if (isBasicInformation && !isMultipleChoice) {
      this.hideBottomBar();
    }

    // Multiple choice
    if (isHandCard && isBasicInformation && isMultipleChoice) {
      if (isNewSelectedValue) {
        this.props.dispatchOpenBottomBar();
      } else if (!hasHandCards) {
        this.hideBottomBar();
      }
    } else if (isBasicInformation && isMultipleChoice && !hasHandCards) {
      this.hideBottomBar();
    }
  }

  isNewSelectedValue(selectedValues, cardValue) {
    return !_.includes(selectedValues, cardValue);
  }

  hasHandCards(stepCards, selectedValues, selectedValue) {
    const cardValues = this.getCurrentStepValuesWithoutDeselectedCardValue(
      selectedValues,
      selectedValue,
    );

    const handCards = this.getCurrentStepHandCards(stepCards, cardValues);

    return handCards.length > 0;
  }

  getCurrentStepValuesWithoutDeselectedCardValue(selectedValues, cardValue) {
    return _.filter(selectedValues, value => value !== cardValue);
  }

  getCurrentStepHandCards(cards, cardValues) {
    return _.filter(
      cards,
      card => _.includes(cardValues, card.value) && card.is_hand,
    );
  }

  handleContact() {
    const { dispatchCloseDialog, history } = this.props;
    dispatchCloseDialog();
    history.push(routesAction.contact());
  }

  handleCardInputChange(event, selectedValue) {
    event.preventDefault();
    const step = this.props.currentOnboardingStep;
    const overviewStep = this.props.currentOverviewStep;
    const inputValue = event.target.value;
    this.props.dispatchSelectStepInputValue(
      step,
      overviewStep,
      [selectedValue],
      inputValue,
    );
  }

  handleAddReference(event, index) {
    event.preventDefault();
    const {
      currentOnboardingStep: step,
      currentOverviewStep: overviewStep,
      dispatchAddReference,
    } = this.props;
    const newElement = {
      internal_id: index,
      link: '',
      checkboxes: [],
      comment: '',
    };
    dispatchAddReference(overviewStep, step, newElement);
  }

  handleDeleteReference(event, reference) {
    event.preventDefault();
    const {
      currentOnboardingStep: step,
      currentOverviewStep: overviewStep,
      dispatchDeleteReference,
    } = this.props;

    dispatchDeleteReference(overviewStep, step, reference);
  }

  handleAddDeadline(date) {
    const {
      currentOnboardingStep: step,
      currentOverviewStep: overviewStep,
    } = this.props;
    const deadline = date ? date.format('DD-MM-YYYY') : null;
    this.props.dispatchSelectStepValue(step, overviewStep, [deadline]);
  }

  handleAddContactInfo(info) {
    const { means_of_contact, phone_number, email } = info;
    const {
      currentOnboardingStep: step,
      currentOverviewStep: overviewStep,
    } = this.props;
    this.props.dispatchSelectStepValue(step, overviewStep, [
      { means_of_contact },
      { phone_number },
      { email },
    ]);
  }

  handleSaveManagementWay(event, managementWay) {
    const {
      match,
      isFetchingProjects,
      dispatchSaveProgress,
      currentOnboardingStep,
      currentOverviewStep,
      dispatchChangeManagementDescription,
    } = this.props;
    const { project_id: projectId } = match.params;

    dispatchSaveProgress(
      {
        way_to_manage: managementWay,
        answered_questions: [
          { key: 'managed_marketplace', question_response: [managementWay] },
        ],
        current_onboarding_step: currentOnboardingStep,
        current_overview_step: currentOverviewStep,
      },
      projectId,
      isFetchingProjects,
    ).then(() => {
      dispatchChangeManagementDescription(managementWay);
    });
  }

  handleGoToSection(event, sectionToGo) {
    event.preventDefault();
    const step = this.props.currentOnboardingStep;
    const overviewStep = this.props.currentOverviewStep;
    this.props.dispatchGoToSection(overviewStep, step, sectionToGo);
  }

  handleProjectBriefInput(event) {
    event.preventDefault();
    const inputField = event.target.name;
    const inputValue = event.target.value;
    const step = this.props.currentOnboardingStep;
    const overviewStep = this.props.currentOverviewStep;

    this.props.dispatchUpdateProjectBrief(
      overviewStep,
      step,
      inputField,
      inputValue,
    );
  }

  getInitialEnabledSteps() {
    const { currentOnboardingSteps } = this.props;

    const mapOnboardingSteps = item =>
      _.get(currentOnboardingSteps, `${item}.onboardingSteps`);

    const removeNulls = item => !_.isNil(item);

    const findFirstEnabled = item =>
      item.find(step => step.disabled !== true).key;

    return _(currentOnboardingSteps)
      .keys()
      .map(mapOnboardingSteps)
      .filter(removeNulls)
      .map(findFirstEnabled)
      .value();
  }

  handleFreeCommentInputChange(event) {
    const { value } = event.target;
    const step = this.props.currentOnboardingStep;
    const overviewStep = this.props.currentOverviewStep;
    this.props.dispatchUpdateFreeComment(overviewStep, step, value);
  }

  handleReferenceInputChange(event, index) {
    const { name, value } = event.target;
    const inputField = name.includes('url') ? 'link' : name;
    const inputValue = value;
    const step = this.props.currentOnboardingStep;
    const overviewStep = this.props.currentOverviewStep;
    this.props.dispatchUpdateReference(
      overviewStep,
      step,
      inputField,
      inputValue,
      index,
    );
  }

  handleProjectUpload(event, fileOrigin) {
    event.preventDefault();
    const file = _.head(event.target.files);
    const step = this.props.currentOnboardingStep;
    const overviewStep = this.props.currentOverviewStep;

    if (!file) {
      return;
    }

    this.props.dispatchProjectFileUpload(overviewStep, step, file, fileOrigin);
  }

  handleRemoveUpload(event, file, fileOrigin) {
    const step = this.props.currentOnboardingStep;
    const overviewStep = this.props.currentOverviewStep;
    this.props.dispatchRemoveUpload(overviewStep, step, file, fileOrigin);
  }

  handleFreelancerBookNow = freelancer => {
    const { dispatchBookNow, history, currentProject: projectId } = this.props;
    dispatchBookNow(projectId, freelancer.id).then(action => {
      if (action.type === 'BOOK_NOW_SUCCESS') {
        history.push(routesAction.payment(projectId));
      }
    });
  };

  handleFreelancerRequestABid = (freelancer, fetchFreelancersCallback) => {
    const {
      dispatchOpenDialog,
      dispatchCloseDialog,
      dispatchRequestBid,
      freelancers,
      currentProject: projectId,
    } = this.props;

    const freelancersBid = freelancers.filter(freela =>
      freela.bids.map(b => b.project_id).includes(parseInt(projectId, 10)),
    );

    dispatchRequestBid(projectId, freelancer.id).then(action => {
      if (action.type === 'REQUEST_BID_SUCCESS' && isEmpty(freelancersBid)) {
        const popup = {
          id: 'freelancer-select-one-popup',
          body: (
            <FreelancerSelectedOnePopup
              handleContinue={event => {
                dispatchCloseDialog();
                this.handleNextStep(event);
              }}
              handleSelectMoreFreelancers={dispatchCloseDialog}
            />
          ),
        };

        dispatchOpenDialog(popup);
      }

      fetchFreelancersCallback();

      if (action.type === 'REQUEST_BID_FAILURE') {
        this.handleShowTooManyCreatorsPopup();
      }
    });
  };

  handleFreelancerDeleteABid = (freelancer, fetchFreelancersCallback) => {
    const { dispatchDeleteBid, currentProject: projectId } = this.props;
    const bidId = _.find(freelancer.bids, { project_id: Number(projectId) }).id;
    dispatchDeleteBid(projectId, bidId).then(() => fetchFreelancersCallback());
  };

  handleFetchFreelancers = params =>
    this.props.dispatchFetchFreelancers(params);

  handleFreelancerCardClicked = (freelancer, fetchFreelancersCallback) => {
    const { currentProject: projectId, dispatchCloseDialog } = this.props;
    const freelancerProfilePopup = {
      id: 'freelancer-profile-popup',
      body: (
        <FreelancerProfilePopup
          projectId={Number(projectId)}
          freelancer={freelancer}
          handleBookNow={this.handleFreelancerBookNow}
          handleRequestABid={this.handleFreelancerRequestABid}
          handleDeleteABid={this.handleFreelancerDeleteABid}
          fetchFreelancers={fetchFreelancersCallback}
          dispatchCloseDialog={dispatchCloseDialog}
        />
      ),
    };

    this.props.dispatchOpenDialog(freelancerProfilePopup);
  };

  handleOnPricingCalculatorMounted = () => {
    const { currentProject: projectId, dispatchGetBudget } = this.props;
    dispatchGetBudget(projectId);
  };

  openContactInformationPopup(callback = () => {}) {
    const { dispatchOpenDialog, user } = this.props;

    const popup = {
      id: 'contact-information-popup',
      body: (
        <ContactInformationPopup
          handleAddContactInfo={this.handleSaveContactInfo}
          handleNextStep={callback}
          user={user}
        />
      ),
    };

    dispatchOpenDialog(popup);
  }

  handleSaveContactInfo(info) {
    const {
      match: {
        params: { project_id: projectId },
      },
      history,
      dispatchSaveProgress,
      dispatchCloseDialog,
      dispatchOpenDialog,
      dispatchHideBottomBar,
    } = this.props;

    // eslint-disable-next-line camelcase
    const { means_of_contact, phone_number, email } = info;

    dispatchSaveProgress(
      {
        means_of_contact,
        phone_number,
        email,
        status: 'pending',
      },
      projectId,
    ).then(() => {
      dispatchOpenDialog(
        {
          id: 'summary-popup',
          body: (
            <EndingEarlyPopup
              handleCloseDialog={() => {
                dispatchCloseDialog();
                dispatchHideBottomBar();
                history.push(routesAction.default());
              }}
            />
          ),
        },
        {
          closeOnEscape: false,
          closeOnDimmerClick: false,
        },
      );
    });
  }

  render() {
    const {
      currentOnboardingStep,
      currentOverviewStep,
      currentOnboardingSteps,
      currentOverviewSteps,
      currentProject: projectId,
      isUploadingAttachment,
      isUploadingProjectPicture,
      bottomBarOpened,
      bottomBarDetailOpened,
      dispatchToggleBottomBarDetail,
      isSavingProject,
      budget,
      minBudget,
      maxBudget,
      recommendedBudget,
      freelancers,
      freelancersPagination,
      isFetchingFreelancers,
    } = this.props;

    return (
      <div>
        <OnboardingStep
          handleCardInputChange={this.handleCardInputChange}
          handleGoToAnswer={this.handleGoToAnswer}
          currentOnboardingStep={currentOnboardingStep}
          currentOverviewStep={currentOverviewStep}
          currentOnboardingSteps={currentOnboardingSteps}
          currentOverviewSteps={currentOverviewSteps}
          handleNextStep={this.handleNextStep}
          handleCardSelected={this.handleCardSelected}
          handlePrevStep={this.handlePrevStep}
          projectId={Number(projectId)}
          handleGoToSection={this.handleGoToSection}
          handleAddReference={this.handleAddReference}
          handleDeleteReference={this.handleDeleteReference}
          handleProjectBriefInput={this.handleProjectBriefInput}
          handleProjectUpload={this.handleProjectUpload}
          handleRemoveUpload={this.handleRemoveUpload}
          isUploadingAttachment={isUploadingAttachment}
          isUploadingProjectPicture={isUploadingProjectPicture}
          isSavingProject={isSavingProject}
          handleReferenceInputChange={this.handleReferenceInputChange}
          handleFreeCommentInputChange={this.handleFreeCommentInputChange}
          budget={budget}
          minBudget={minBudget}
          maxBudget={maxBudget}
          recommendedBudget={recommendedBudget}
          handleBudgetChange={this.handleBudgetChange}
          onPricingCalculatorMounted={this.handleOnPricingCalculatorMounted}
          freelancers={freelancers}
          freelancersPagination={freelancersPagination}
          handleFetchFreelancers={this.handleFetchFreelancers}
          handleFreelancerBookNow={this.handleFreelancerBookNow}
          handleFreelancerRequestABid={this.handleFreelancerRequestABid}
          handleFreelancerDeleteABid={this.handleFreelancerDeleteABid}
          isFetchingFreelancers={isFetchingFreelancers}
          handleShowFreelancerChooserPopup={
            this.handleShowFreelancerChooserPopup
          }
          handleFreelancerCardClicked={this.handleFreelancerCardClicked}
          handleAddDeadline={this.handleAddDeadline}
          handleAddContactInfo={this.handleAddContactInfo}
          handleSaveManagementWay={this.handleSaveManagementWay}
          handleGoToDashboard={this.handleGoToDashboard}
        />
        <BottomBar
          open={bottomBarOpened}
          openDetail={bottomBarDetailOpened}
          header={
            <BottomBarHeader
              hasDetail={bottomBarDetailOpened}
              toggleDetail={dispatchToggleBottomBarDetail}
              hide={this.hideBottomBar}
              talkToManager={this.openContactInformationPopup}
            />
          }
          body={<BottomBarDetail />}
        />
      </div>
    );
  }
}

Onboarding.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      project_id: PropTypes.string,
    }),
  }),
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
  currentOnboardingSteps: PropTypes.object,
  currentOverviewStep: PropTypes.string,
  currentOnboardingStep: PropTypes.string,
  currentOverviewSteps: PropTypes.array,
  currentProject: PropTypes.string,
  bottomBarOpened: PropTypes.bool,
  bottomBarDetailOpened: PropTypes.bool,
  dispatchSetNextStep: PropTypes.func,
  dispatchSetPrevStep: PropTypes.func,
  dispatchSaveProgress: PropTypes.func,
  dispatchSelectStepValue: PropTypes.func,
  dispatchSelectStepInputValue: PropTypes.func,
  dispatchGoToQuestionStep: PropTypes.func,
  dispatchGoToSection: PropTypes.func,
  dispatchUpdateProjectBrief: PropTypes.func,
  dispatchAddReference: PropTypes.func,
  dispatchDeleteReference: PropTypes.func,
  dispatchUpdateReference: PropTypes.func,
  dispatchUpdateFreeComment: PropTypes.func,
  dispatchOpenDialog: PropTypes.func,
  dispatchCloseDialog: PropTypes.func,
  dispatchAddDropboxFolder: PropTypes.func,
  dispatchRemoveDropboxFolder: PropTypes.func,
  dispatchProjectFileUpload: PropTypes.func,
  dispatchRemoveUpload: PropTypes.func,
  dispatchChangeManagementDescription: PropTypes.func,
  dispatchErrorMessage: PropTypes.func,
  isUploadingAttachment: PropTypes.bool,
  isUploadingProjectPicture: PropTypes.bool,
  dispatchOpenBottomBar: PropTypes.func,
  dispatchToggleBottomBarDetail: PropTypes.func,
  dispatchHideBottomBar: PropTypes.func,
  isFetchingProjects: PropTypes.bool,
  isSavingProject: PropTypes.bool,
  budget: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  minBudget: PropTypes.number,
  maxBudget: PropTypes.number,
  recommendedBudget: PropTypes.number,
  dispatchSetBudget: PropTypes.func,
  dispatchGetBudget: PropTypes.func,
  freelancers: PropTypes.array,
  freelancersPagination: PropTypes.object,
  dispatchFetchFreelancers: PropTypes.func,
  isFetchingFreelancers: PropTypes.bool,
  dispatchUpdateFreelancerPreFilter: PropTypes.func,
  dispatchRequestBid: PropTypes.func,
  dispatchDeleteBid: PropTypes.func,
  dispatchBookNow: PropTypes.func,
  user: PropTypes.object,
  dispatchGetProject: PropTypes.func,
  project: PropTypes.object,
};

const mapStateToProps = state => {
  const overviewStep = state.overview.currentStep;
  const currentOnboardingSteps = state.onboarding;
  const { overviewSteps } = state.overview;
  const { user } = state.authentication;
  const { project } = state.projectView;

  return {
    currentOverviewSteps: overviewSteps,
    currentOverviewStep: overviewStep,
    currentOnboardingStep: state.onboarding.currentStep,
    currentOnboardingSteps,
    currentProject: state.dashboard.currentProject,
    bottomBarOpened: state.bottomBar.open,
    bottomBarDetailOpened: state.bottomBar.openDetail,
    isUploadingAttachment: currentOnboardingSteps.isUploadingAttachment,
    isUploadingProjectPicture: currentOnboardingSteps.isUploadingProjectPicture,
    isFetchingProjects: state.dashboard.isFetchingProjects,
    isSavingProject: state.onboarding.isSavingProject,
    budget: state.onboarding.budget,
    minBudget: state.onboarding.minBudget,
    maxBudget: state.onboarding.maxBudget,
    recommendedBudget: state.onboarding.recommendedBudget,
    managementWay: currentOnboardingSteps.managementWay,
    freelancers: state.onboarding.freelancersPage.freelancers,
    freelancersPagination: state.onboarding.freelancersPage.pagination,
    isFetchingFreelancers: state.onboarding.isFetchingFreelancers,
    user,
    project,
  };
};

const mapDispatchToProps = dispatch => ({
  dispatchSetNextStep: overviewStep => {
    dispatch(goToStep(overviewStep));
  },

  dispatchSetPrevStep: overviewStep => {
    dispatch(setPrevStep(overviewStep));
  },

  dispatchSaveProgress: (saveinfo, projectId, isFetchingProjects) =>
    dispatch(saveProgress(saveinfo, projectId, isFetchingProjects)),
  dispatchSelectStepValue: (step, overviewStep, selectedValue) => {
    dispatch(selectStepValue(step, overviewStep, selectedValue));
  },

  dispatchSelectStepInputValue: (
    step,
    overviewStep,
    selectedValue,
    inputValue,
  ) => {
    dispatch(
      selectStepInputValue(step, overviewStep, selectedValue, inputValue),
    );
  },

  dispatchGoToQuestionStep: onboardingStep => {
    dispatch(setCurrentOnboardingStep(onboardingStep));
  },

  dispatchGoToSection: (overviewStep, onboardingStep, sectionToGo) => {
    dispatch(setCurrentSection(overviewStep, onboardingStep, sectionToGo));
  },

  dispatchProjectFileUpload: (
    overviewStep,
    onboardingStep,
    file,
    fileOrigin,
  ) => {
    switch (fileOrigin) {
      case 'attachment':
        dispatch(uploadingAttachmentRequest());
        break;
      case 'project_picture':
        dispatch(uploadingProjectPictureRequest());
        break;
      default:
        dispatch(addFlashMessage(['Not recognized file origin'], 'error'));
    }
    dispatch(uploadFile(overviewStep, onboardingStep, file, fileOrigin));
  },

  dispatchRemoveUpload: (overviewStep, onboardingStep, file, fileOrigin) => {
    dispatch(removeUpload(overviewStep, onboardingStep, file, fileOrigin));
  },

  dispatchUpdateProjectBrief: (
    overviewStep,
    onboardingStep,
    inputField,
    inputValue,
  ) => {
    dispatch(
      updateProjectBrief(overviewStep, onboardingStep, inputField, inputValue),
    );
  },

  dispatchAddReference: (overviewStep, onboardingStep, newElement) => {
    dispatch(addReference(overviewStep, onboardingStep, newElement));
  },

  dispatchDeleteReference: (overviewStep, onboardingStep, reference) => {
    dispatch(deleteReferenceVideo(overviewStep, onboardingStep, reference));
  },

  dispatchUpdateReference: (
    overviewStep,
    onboardingStep,
    inputField,
    inputValue,
    index,
  ) => {
    dispatch(
      updateReference(
        overviewStep,
        onboardingStep,
        inputField,
        inputValue,
        index,
      ),
    );
  },

  dispatchUpdateFreeComment: (overviewStep, onboardingStep, inputValue) => {
    dispatch(updateFreeComment(overviewStep, onboardingStep, inputValue));
  },

  dispatchAddDropboxFolder: (
    overviewStep,
    onboardingStep,
    dropboxFoldersPath,
  ) => {
    dispatch(
      addDropboxFolder(overviewStep, onboardingStep, dropboxFoldersPath),
    );
  },

  dispatchRemoveDropboxFolder: (overviewStep, onboardingStep) => {
    dispatch(removeDropboxFolder(overviewStep, onboardingStep));
  },
  dispatchOpenDialog: (content, options) => {
    dispatch(openDialog(content, options));
  },

  dispatchCloseDialog: () => {
    dispatch(closeDialog());
  },
  dispatchOpenBottomBar: () => dispatch(openBottomBar()),
  dispatchToggleBottomBarDetail: () => dispatch(toggleBottomBarDetail()),
  dispatchHideBottomBar: () => dispatch(hideBottomBar()),
  dispatchSetBudget: data => dispatch(setBudget(data)),
  dispatchGetBudget: projectId => dispatch(getBudget(projectId)),
  dispatchFetchFreelancers: params => dispatch(fetchFreelancers(params)),
  dispatchChangeManagementDescription: managementWay =>
    dispatch(changeManagementDescription(managementWay)),
  dispatchUpdateFreelancerPreFilter: params =>
    dispatch(updateFreelancerPreFilter(params)),
  dispatchRequestBid: (projectId, freelancerId) =>
    dispatch(requestBid(projectId, freelancerId)),
  dispatchDeleteBid: (projectId, bidId) =>
    dispatch(deleteBid(projectId, bidId)),
  dispatchBookNow: (projectId, freelancerId) =>
    dispatch(bookNow(projectId, freelancerId)),
  dispatchErrorMessage: messages =>
    dispatch(addFlashMessage(messages, 'error')),
  dispatchGetProject: id => dispatch(getProject(id)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Onboarding);



// WEBPACK FOOTER //
// ./src/containers/Onboarding/Onboarding.js